<script>
export default {
  props: {
    value: { type: Array, required: true },
    groupLabel: { type: String, required: true },
    batches: { type: Array, required: true },
  },

  computed: {
    options() { return this.batches.map(x => ({ text: `${x.name} (${x.type_of_hen})`, value: x.name })) },
    checked: {
      get() { return this.value },
      set(val) { this.$emit('input', val) },
    },
  },
}
</script>

<template>
  <b-form-group :label="groupLabel">
    <b-form-checkbox-group v-model="checked" :options="options" stacked />
  </b-form-group>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/BatchesCheckboxes.vue